export const PIXEL_PERSON_SKIN_TONE_PRESETS = {
  1: '#FFDBB4',
  2: '#EDB98A',
  3: '#D08B5B',
  4: '#AE5D29',
  5: '#614335',
};

/** Presets used for name-seeded sprites — avoids dark tones that read badly at chip size. */
export const PIXEL_PERSON_AUTO_SKIN_PRESET_KEYS = [1, 2, 3];

/** Hair colors for name-seeded sprites — excludes near-black (#1C1C1C, #2C1B18). */
export const PIXEL_PERSON_AUTO_HAIR_COLORS = [
  '#4A3728',
  '#8B4513',
  '#A0522D',
  '#D2691E',
  '#DAA520',
  '#FFD700',
  '#F4A460',
  '#CD853F',
  '#B22222',
  '#800020',
];

/** White hardhat reserved for context/system agents — not in random headwear pool. */
export const SYSTEM_AGENT_HEADWEAR_ID = 'systemHardhat';

/** Black helmet reserved for the Master Agent — not in random headwear pool. */
export const MASTER_AGENT_HEADWEAR_ID = 'masterHelmet';

/** Fixed sprite palette for context/system agents. */
export const SYSTEM_AGENT_PIXEL_COLORS = {
  tone: 2,
  hair: '#4A3728',
  hairStyle: 'parted',
  headwear: SYSTEM_AGENT_HEADWEAR_ID,
  shirt: '#7c3aed',
  pants: '#2C3E50',
  shoes: '#37474F',
};

/** Fixed sprite palette for the tenant Master Agent orchestrator. */
export const MASTER_AGENT_PIXEL_COLORS = {
  tone: 2,
  hair: '#4A3728',
  hairStyle: 'parted',
  headwear: MASTER_AGENT_HEADWEAR_ID,
  shirt: '#18181b',
  pants: '#27272a',
  shoes: '#1C1C1C',
};

export const PIXEL_PERSON_HAIR_COLORS = [
  '#2C1B18',
  '#4A3728',
  '#8B4513',
  '#A0522D',
  '#D2691E',
  '#DAA520',
  '#FFD700',
  '#F4A460',
  '#CD853F',
  '#B22222',
  '#800020',
  '#1C1C1C',
];

export const PIXEL_PERSON_SHIRT_COLORS = [
  '#e94560',
  '#0F3460',
  '#16C79A',
  '#FF6B35',
  '#7B2D8E',
  '#2196F3',
  '#4CAF50',
  '#FF9800',
  '#E91E63',
  '#00BCD4',
  '#8BC34A',
  '#F44336',
  '#3F51B5',
  '#ECEFF1',
];

export const PIXEL_PERSON_PANTS_COLORS = [
  '#1A1A2E',
  '#2C3E50',
  '#3B3B3B',
  '#1B4332',
  '#4A4A4A',
  '#2196F3',
  '#5D4037',
  '#455A64',
  '#6B4226',
  '#1565C0',
  '#BDB76B',
  '#F5F5DC',
];

export const PIXEL_PERSON_SHOE_COLORS = [
  '#1C1C1C',
  '#3E2723',
  '#5D4037',
  '#795548',
  '#B0BEC5',
  '#F44336',
  '#2196F3',
  '#424242',
  '#8D6E63',
  '#D32F2F',
];

/** Work-cap colors for field-service sprites. */
export const PIXEL_PERSON_CAP_COLORS = [
  '#1565C0',
  '#0D47A1',
  '#37474F',
  '#E65100',
  '#BF360C',
  '#33691E',
  '#455A64',
];

export const PIXEL_PERSON_BEANIE_COLORS = [
  '#C0392B',
  '#2E7D32',
  '#455A64',
  '#E65100',
  '#6A1B9A',
  '#1565C0',
];

export const PIXEL_PERSON_HEADWEAR_PALETTES = {
  hardhat: { headwear: '#FFC107', headwearAccent: '#F57F17' },
  systemHardhat: { headwear: '#FAFAFA', headwearAccent: '#9E9E9E' },
  masterHelmet: { headwear: '#1C1C1C', headwearAccent: '#424242' },
  cap: null,
  beanie: null,
  bucket: { headwear: '#A1887F', headwearAccent: '#5D4037' },
  visor: { headwear: '#ECEFF1', headwearAccent: '#90A4AE' },
};
